import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import SnippetFormLayout from './containers/Form';
import SnippetsGridLayout from './containers/Grid';

export default function SnippetLayout() {
  return <Router>
    <PrivateRoute exact path="/cms/snippets" component={SnippetsGridLayout} />
    <PrivateRoute path={["/cms/snippets/add", "/cms/snippets/:id"]} component={SnippetFormLayout} />
  </Router>
}
